import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: 1,
    borderRadius: theme.shape.borderRadius,
    borderColor: theme.palette.grey[400],
    borderStyle: 'solid',
    cursor: 'pointer',
  },
}));
